import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { FilterValuePipe } from './pipes/filter-value.pipe';
import { FilterForPipe } from './pipes/filter-for.pipe';
import { ToBooleanPipe } from './pipes/to-boolean.pipe';
import { QrCodePipe } from './pipes/qr-code.pipe';
import { CountDownPipe } from './pipes/count-down.pipe';
import { HumanizeDatePipe } from './pipes/humanize-date.pipe';
import { IsDatePassedPipe } from './pipes/is-date-passed.pipe';
import { CountOccurrencesPipe } from './pipes/count-occurences.pipe';
import { HumanizePhonePipe } from './pipes/humanize-phone.pipe';
import { LobbyErrorMessagePipe } from './pipes/lobby-error-message.pipe';
import { BooleanRawvaluePipe } from './pipes/boolean-rawvalue.pipe';
import { TranslateColumnsPipe } from './pipes/translate-columns.pipe';
import { TranslateColumnPipe } from './pipes/translate-column.pipe';
import { HasTranslationPipe } from './pipes/has-translation.pipe';
import { IsInfiniteDatePipe } from './pipes/is-infinite-time.pipe';
import { AuthImgSourcePipe } from './pipes/auth-img-source.pipe';
import { ToStringPipe } from './pipes/to-string.pipe';
import { HumanizeIfInRangeDatePipe } from './pipes/humanize-if-in-range-date.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { FormatDateWithTimezonePipe } from './pipes/format-date-with-timezone.pipe';

@NgModule({
  declarations: [
    FilterValuePipe,
    FilterForPipe,
    ToBooleanPipe,
    QrCodePipe,
    CountDownPipe,
    HumanizeDatePipe,
    IsDatePassedPipe,
    CountOccurrencesPipe,
    HumanizePhonePipe,
    LobbyErrorMessagePipe,
    BooleanRawvaluePipe,
    TranslateColumnsPipe,
    TranslateColumnPipe,
    HasTranslationPipe,
    IsInfiniteDatePipe,
    AuthImgSourcePipe,
    ToStringPipe,
    HumanizeIfInRangeDatePipe,
    FormatDateWithTimezonePipe,
    FileSizePipe
  ],
  imports: [
    CommonModule
  ],
  providers: [
    FilterValuePipe,
    FilterForPipe,
    ToBooleanPipe,
    AsyncPipe,
    HumanizePhonePipe,
    LobbyErrorMessagePipe,
    BooleanRawvaluePipe,
    TranslateColumnPipe,
    DatePipe,
    CountDownPipe,
    HumanizeDatePipe
  ],
  exports: [
    FilterValuePipe,
    FilterForPipe,
    ToBooleanPipe,
    QrCodePipe,
    CountDownPipe,
    HumanizeDatePipe,
    IsDatePassedPipe,
    CountOccurrencesPipe,
    HumanizePhonePipe,
    LobbyErrorMessagePipe,
    TranslateColumnPipe,
    TranslateColumnsPipe,
    HasTranslationPipe,
    IsInfiniteDatePipe,
    AuthImgSourcePipe,
    ToStringPipe,
    HumanizeIfInRangeDatePipe,
    FormatDateWithTimezonePipe,
    FileSizePipe
  ]
})
export class UtilsModule { }
